import script from "./RichText.vue?vue&type=script&setup=true&lang=ts"
export * from "./RichText.vue?vue&type=script&setup=true&lang=ts"

import "./RichText.vue?vue&type=style&index=0&id=916a1356&lang=scss&scoped=true"
import "./RichText.vue?vue&type=style&index=1&id=916a1356&lang=css"
import "./RichText.vue?vue&type=style&index=2&id=916a1356&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-916a1356"]])

export default __exports__